module.exports = __webpack_public_path__ + "static/about-us-amo-logo-297228780d1cd37c941cce7ab7c2db86.png";